export default __webpack_public_path__ + "static/media/apple-watch.884c5ea7.png";